import axiosInstance from "../services/axiosInstance";

export interface ApiRole {
  roleId: number;
  roleCode: string | null;
  roleName: string;
  description: string;
  roleDescription: string; 
  isAvailableForDelegation: boolean;
  isSystemRole: boolean;
  defaultDashboardUrl: string | null;
  isActive: boolean;
  createdBy: number | null;
  createdAt: string | null;
  updatedAt: string | null;
  updatedBy?: number | null;
}

// Response for POST /Role
export interface CreateRoleResponse {
  id: number;
}

export interface AllRolesResponse {
  totalCount: number;
  roles: {
    roleId: number;
    roleName: string;
    roleDescription: string;
    isActive: boolean;
    isAvailableForDelegation: boolean;
  }[];
}

export interface RoleWithPermissionsResponse {
  roleId: number;
  roleName: string;
  roleCode: string;
  roleDescription: string;
  isSystemRole: boolean;
  isActive: boolean;
  isAvailableForDelegation: boolean;
  permissions: {
    roleModulePermissionId: number;
    roleId: number;
    moduleId: number;
    moduleScreenId: number;
    moduleName: string;
    canView: boolean;
    canAdd: boolean;
    canEdit: boolean;
    canDelete: boolean;
    canApprove: boolean;
    canLock: boolean;
    canRestore: boolean;
    canManageUsers: boolean;
    isActive: boolean;
  }[];
}

export interface UpdateRolePayload {
  roleId: number;
  roleCode: string;
  roleName: string;
  description: string;
  isSystemRole: boolean;
  defaultDashboardUrl: string;
  isActive: boolean;
  isAvailableForDelegation: boolean;
  updatedBy: number;
}

export const getAuthHeader = () => { 
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// GET ROLES WITH PAGINATION
export const getRoles = async (pageNumber = 1, pageSize = 10) => {
  const response = await axiosInstance.get(
    `/Role/roles?pageNumber=${pageNumber}&pageSize=${pageSize}`,{
      headers: getAuthHeader(),
    }
  );
  return response.data; // returns { totalCount, roles, ... }
};

export const getAllRoles = async (
  pageNumber = 1,
  pageSize = 100
) => {
  const response = await axiosInstance.get(
    `/Role/roles/all?pageNumber=${pageNumber}&pageSize=${pageSize}`,{
      headers: getAuthHeader(),
    }
  );

  return response.data;
};


// CREATE ROLE
export const createRole = async (payload: {
  roleCode: string;
  roleName: string;
  description: string;
  isSystemRole: boolean;
  isAvailableForDelegation: boolean; 
  defaultDashboardUrl: string | null;
  createdBy: number;
}): Promise<{
  roleId: number; id: number 
}> => {
  const response = await axiosInstance.post("/Role", payload,{
    headers: getAuthHeader(),
  });
  return response.data;
};


// UPDATE ROLE
export const updateRole = async (
  roleId: number,
  payload: UpdateRolePayload
) => {
  const response = await axiosInstance.put(`/Role/${roleId}`, payload,{
    headers: getAuthHeader(),
  });
  return response.data;
};


// DELETE ROLE
export const deleteRole = async (roleId: number): Promise<{ affected: boolean }> => {
  const response = await axiosInstance.delete(`/Role/${roleId}`,{
    headers: getAuthHeader(),
  });
  return response.data;
};

// export const deleteRole = async (roleId: number) => {
//   const response = await axiosInstance.delete<{
//     success: boolean;
//     message: string;
//   }>(`/roles/${roleId}`);

//   return response.data;
// };


export const getRoleWithPermissions = async (
  roleId: number
): Promise<RoleWithPermissionsResponse> => {
  const response = await axiosInstance.get(
    `/Role/${roleId}/with-permissions`, {
      headers: getAuthHeader(),
    }
  );
  return response.data;
};


